module.exports = __webpack_public_path__ + "img/娇点.5a7cc96.png";